import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toggleMenu, closeMenu } from 'data/actions/app';

import MobileMenuLink from 'components/molecules/mobileMenuLink';

class MobileMenuLinkContainer extends Component {
    render() {
        return <MobileMenuLink {...this.props} />;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onMenuClick: () => {
            dispatch(toggleMenu());
        },
        onResizeToDesktop: () => {
            dispatch(closeMenu());
        }
    };
};

MobileMenuLinkContainer = withRouter(
    connect(null, mapDispatchToProps)(MobileMenuLinkContainer)
);

export default MobileMenuLinkContainer;



// WEBPACK FOOTER //
// ./src/data/containers/mobileMenuLink.js